<template>
  <BlBackdrop
    title="Import databank from center"
    label="Import databank"
    :disabled="isDisabledSubmit"
    :submitLoading="submitLoading"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onImport"
  >
    <div
      class="flex flex-col gap-5 px-8 overflow-y-auto"
      :style="{ width: '40rem', maxHeight: 'calc(100vh - 14rem)' }"
    >
      <div class="grid items-center grid-cols-6 gap-4 py-4">
        <BlSelectBox
          class="col-span-6"
          label="Select center"
          asterisk
          search
          v-model="centerInput"
          placeholder="Select center"
          :options="centerOptions"
          @change="centerInput = $event"
        />
        <BlInputText
          class="col-span-6"
          :input="databankNameInput"
          @changed="inputHandler"
        />
        <BlInputText
          class="col-span-6"
          :input="descriptionInput"
          @changed="inputHandler"
        />

        <!--  -->
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { TIMEZONES } from "@/plugins/timezone.js";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlInputText from "../../BlInputText.vue";
import BlSelectBox from "../../BlSelectBox.vue";
import { mapActions } from "vuex";

export default {
  name: "ImportDatabankModal",
  components: {
    BlBackdrop,
    BlTextSubtitle1,
    BlInputText,
    BlSelectBox
  },
  props: {
    centers: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      submitLoading: false,
      nameInput: {
        label: "Center name",
        placeholder: "Type name",
        asterisk: true,
        model: ""
      },
      centerInput: null,
      dateFormatInput: "DD/MM/YYYY",
      dateFormatOptions: [
        { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
        { value: "MM/DD/YYYY", label: "MM/DD/YYYY" }
      ],
      timezoneInput: "Asia/Jakarta",
      timezoneOptions: TIMEZONES.map(t => ({
        value: t.timezone,
        label: t.timezone
      })),
      currencyInput: "IDR",
      currencyOptions: [
        { value: "IDR", label: "IDR (Rp)" },
        { value: "USD", label: "USD ($)" },
        { value: "SGD", label: "SGD ($)" },
        { value: "MYR", label: "MYR (RM)" },
        { value: "PHP", label: "PHP (₱)" },
        { value: "THB", label: "THB (฿)" },
        { value: "VND", label: "VND (₫)" }
      ],
      //
      databankNameInput: {
        label: "Databank name",
        placeholder: "Type name",
        model: "",
        asterisk: true
      },
      descriptionInput: {
        label: "Description",
        placeholder: "Type description",
        textarea: true,
        model: ""
      },
      contactEmailInput: {
        label: "Email",
        placeholder: "Type email",
        model: ""
      },
      contactPhoneNumberInput: {
        label: "Phone number",
        placeholder: "Type phone number",
        model: ""
      },
      centerAddressInput: {
        label: "Center address",
        placeholder: "Type address",
        textarea: true,
        model: ""
      }
    };
  },
  computed: {
    isDisabledSubmit() {
      if (!this.centerInput || !this.databankNameInput.model) return true;
      return false;
    },
    centerOptions() {
      return this.centers.map(center => ({
        value: center.id,
        label: center.name
      }));
    }
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(["importDatabank"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    async onImport() {
      const params = {
        center_id: this.centerInput,
        databank: {
          name: this.databankNameInput.model,
          description: this.descriptionInput.model
        }
      };
      this.submitLoading = true;
      const { success } = await this.importDatabank(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/databanks/ImportDatabankModal.vue